import { action, computed, observable } from "mobx";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { ApiStatus } from "Custom/Models/Enums/ApiStatus";
import { Client, Server } from "Custom/Globals/AppUrls";
import { SuperAdminModel, CustomerWithPortalAccessModel, CustomerWithPortalAccessModelDTO } from "Custom/Models/DashboardModels/SuperAdminModel";
import { FieldType } from "Core/Utils/Utils";
import { StoresInstance } from "Core/Base";

export class SuperAdminViewModel extends ViewModelBase<SuperAdminModel> {
    @observable
    public apiStatus: ApiStatus = ApiStatus.loading;

    constructor() {
        super(new SuperAdminModel());

        StoresInstance.domain.SuperAdminStore.clearSelectedCustomer();
        this.loadCustomers();
    }

    @computed
    public get ApiStatus(): ApiStatus {
        return this.apiStatus;
    }

    @action
    public setApiStatus(apiStatus: ApiStatus) {
        this.apiStatus = apiStatus;
    }

    @action
    public clearFilters = (): void => {
        this.model.clearFilters();
    };

    @action
    public loadCustomers = async (): Promise<void> => {
        this.setApiStatus(ApiStatus.loading);

        try {
            const apiResult = await this.Get<CustomerWithPortalAccessModelDTO[]>(Server.Api.SuperAdmin.GetCustomersWithPortalAccess);

            if (apiResult.wasSuccessful && apiResult.payload) {
                this.model.setCustomers(apiResult.payload);
                this.setApiStatus(ApiStatus.success);
            } else {
                this.setApiStatus(ApiStatus.error);
            }
        } catch (err) {
            this.setApiStatus(ApiStatus.error);
        } finally {
            //
        }
    };

    @action
    public handleViewCustomer = (customer: CustomerWithPortalAccessModel) => {
        // Navigate to customer's property dashboard
        if (customer.propertyId) {
            StoresInstance.domain.SuperAdminStore.setSelectedCustomer(customer);
            StoresInstance.domain.AccountStore.setPropertyId(customer.propertyId);
            this.history.push(Client.Path.Dashboard.replace(":propertyId", customer.propertyId));
        }
    };

    @computed
    public get filteredCustomers(): CustomerWithPortalAccessModel[] {
        return this.model.getFilteredCustomers();
    }

    @computed
    public get groupedCustomers(): Array<{
        customer: CustomerWithPortalAccessModel;
        properties: CustomerWithPortalAccessModel[];
    }> {
        return this.model.getGroupedCustomers();
    }

    @computed
    public get customers(): CustomerWithPortalAccessModel[] {
        return this.model.customers;
    }

    @computed
    public get customerFilter(): string {
        return this.model.customerFilter;
    }

    @computed
    public get plotFilter(): string {
        return this.model.plotFilter;
    }

    @computed
    public get houseTypeFilter(): string {
        return this.model.houseTypeFilter;
    }

    @computed
    public get developmentFilter(): string {
        return this.model.developmentFilter;
    }

    @action
    public setCustomerFilter = (value: string): void => {
        this.model.setCustomerFilter(value);
    };

    @action
    public setPlotFilter = (value: string): void => {
        this.model.setPlotFilter(value);
    };

    @action
    public setHouseTypeFilter = (value: string): void => {
        this.model.setHouseTypeFilter(value);
    };

    @action
    public setDevelopmentFilter = (value: string): void => {
        this.model.setDevelopmentFilter(value);
    };

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }
}
